import MaintenancePlan from './MaintenancePlan.vue'

export default MaintenancePlan 


// WEBPACK FOOTER //
// ./src/pages/MaintenancePlan/index.js